import { css } from "styled-components";
export const boldTypographyMixin = css `
  font-weight: 600;
`;
export const textUppercaseMixin = css `
  /* stylelint-disable-next-line declaration-property-value-allowed-list */
  text-transform: uppercase;

  &:lang(ko-kr),
  &:lang(ja-jp),
  &:lang(tr-tr),
  &:lang(el-gr),
  &:lang(th-th),
  &:lang(zh-tw) {
    text-transform: none;
  }
`;
//# sourceMappingURL=typography.js.map